import React from 'react';

import { Image } from 'shared-frontend-components/dist/atoms';

export const BookmarkItemImage = ({ bookmarkItem }) => {
  const imageSrc = bookmarkItem.logoUrl;

  return <Image src={imageSrc} alt={imageSrc} className="bookmark-item-image-jobs" />;
};
